"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.baseDefaultProps = void 0;

var React = _interopRequireWildcard(require("react"));

var _config = _interopRequireDefault(require("./config"));

var _error = _interopRequireDefault(require("./error"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var isDefined = function isDefined(v) {
  return v !== undefined;
};

var objectFilter = function objectFilter(obj, fn) {
  return Object.keys(obj).filter(function (key) {
    return fn(obj[key]);
  }).reduce(function (pre, cur) {
    return _objectSpread(_objectSpread({}, pre), {}, _defineProperty({}, cur, obj[cur]));
  }, {});
};

var filterUndefined = function filterUndefined(obj) {
  return objectFilter(obj, isDefined);
};

var baseDefaultProps = {
  className: '',
  onError: null
};
exports.baseDefaultProps = baseDefaultProps;

var KZUIComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(KZUIComponent, _React$Component);

  var _super = _createSuper(KZUIComponent); // TODO wait to merge


  function KZUIComponent(props) {
    var _this;

    _classCallCheck(this, KZUIComponent);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "innerInitFlag", void 0);

    _this.autoBind('classname', 'innerInitStateFromProps');

    _this.innerInitFlag = true;

    _this.innerInitStateFromProps(props);

    return _this;
  }

  _createClass(KZUIComponent, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.innerInitFlag = false;
      this.innerInitStateFromProps(nextProps);
    } // raise an error

  }, {
    key: "raiseError",
    value: function raiseError(code, message) {
      var e = new _error["default"](code, message);

      if (this.props.onError) {
        this.props.onError(e);
      } else {
        throw e;
      }
    } // init internal state from props
    // eslint-disable-next-line no-unused-vars,class-methods-use-this

  }, {
    key: "innerInitStateFromProps",
    value: function innerInitStateFromProps(props) {
      var newState = this.initStateFromProps(props);
      if (!newState) return;

      if (this.innerInitFlag) {
        this.state = newState;
      } else {
        this.setState(filterUndefined(newState));
      }
    }
  }, {
    key: "initStateFromProps",
    value: function initStateFromProps(props) {
      return this.state;
    }
  }, {
    key: "classname",
    value: function classname(name) {
      var stateClasses = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var noPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var noPropCls = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var baseName = noPrefix ? name : "".concat(_config["default"].cssPrefix).concat(name);
      var classNames = [baseName];
      Object.keys(stateClasses).forEach(function (stateName) {
        if (stateClasses[stateName]) {
          classNames.push(stateName);
        }
      });

      if (!noPropCls && this.props.className) {
        classNames.push(this.props.className);
      }

      return classNames.join(' ');
    }
    /**
     * bind event handler for performance reason
     * @see https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/jsx-no-bind.md
     */

  }, {
    key: "autoBind",
    value: function autoBind() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      for (var i = 0; i < args.length; i += 1) {
        var func = this[args[i]];

        if (func) {
          this[args[i]] = func.bind(this);
        }
      }
    }
    /**
     * store an DOM element in refs
     * @see https://github.com/yannickcr/eslint-plugin-react/blob/master/docs/rules/no-string-refs.md
     */

  }, {
    key: "storeRef",
    value: function storeRef(name) {
      var _this2 = this;

      return function (c) {
        _this2[name] = c;
      };
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", null);
    }
  }]);

  return KZUIComponent;
}(React.Component);

exports["default"] = KZUIComponent;

_defineProperty(KZUIComponent, "defaultProps", baseDefaultProps);